/**
 * Referral Link Sharing Utilities
 *
 * Shared copy/share helpers used by both usePartnerDashboard and useCustomerReferral.
 * Avoids duplicating Clipboard + Share logic across hooks.
 *
 * Epic: #1529 — DD Affiliate + Customer Referral Program
 */

import * as Clipboard from 'expo-clipboard';
import { Share } from 'react-native';

/**
 * Copy a referral URL to the clipboard.
 * No-op if the URL is falsy.
 */
export async function copyReferralUrl(url: string | null | undefined): Promise<void> {
  if (url) {
    await Clipboard.setStringAsync(url);
  }
}

/**
 * Share a referral URL via the native share sheet.
 * Silently swallows cancellation or unavailability errors.
 */
export async function shareReferralUrl(url: string | null | undefined): Promise<void> {
  if (!url) return;
  try {
    await Share.share({ message: url, url });
  } catch {
    // User cancelled share or share not available
  }
}
